import { useTranslation } from 'react-i18next'

import { SquaresFourIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Alert, Divider, Text } from '@reveni-io/reveni-ui'

import { getBlockInternalName, getBlockTypeLabel } from './helpers'
import * as Styles from './styles'

const VisibilityCriterionUsedIn = ({ blockUids, layout }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <>
      <Divider />
      <Styles.Container>
        <Text type="titleM">{t('Criterios usados en')}:</Text>
        {!blockUids.length && (
          <Alert type="info">
            {t(
              'Este criterio de visibilidad todavía no está asociado a ningún bloque del layout de la Order tracking page.'
            )}
          </Alert>
        )}
        {blockUids.length > 0 && (
          <Styles.BlockList>
            {blockUids.map(blockUid => (
              <Styles.Block key={blockUid}>
                <SquaresFourIcon size={20} />
                <Text type="bodyMBold">{getBlockInternalName(blockUid, layout) || t(getBlockTypeLabel(blockUid))}</Text>
                {getBlockInternalName(blockUid, layout) && (
                  <Text type="bodySRegular" color={theme.colors.text.muted}>
                    {t(getBlockTypeLabel(blockUid))}
                  </Text>
                )}
              </Styles.Block>
            ))}
          </Styles.BlockList>
        )}
      </Styles.Container>
    </>
  )
}

export default VisibilityCriterionUsedIn
